import texts from "../utils/texts"
import moment from "moment"
import _ from "lodash"


export const researchStages = {
  initialAppointment: "initial_appointment",
  firstYear: "01_00_call",
  secondYear: "02_visit",
  thirdYear: "03_00_call",
  forthYear: "04_00_visit",
  fifthYear: "05_00_call",
  sixthYear: "06_00_visit",
  seventhYear: "07_00_call",
  eighthYear: "08_00_visit",
  ninthYear: "09_00_call",
}

export const researchStageTypes = {
  ...researchStages,
  "unplanned": "unplanned",
}

const researchStagesInHebrew = {
  [researchStages.initialAppointment]: texts.visit00,
  [researchStages.firstYear]: texts.firstYear,
  [researchStages.secondYear]: texts.secondYear,
  [researchStages.thirdYear]: texts.thirdYear,
  [researchStages.forthYear]: texts.forthYear,
  [researchStages.fifthYear]: texts.fifthYear,
  [researchStages.sixthYear]: texts.sixthYear,
  [researchStages.seventhYear]: texts.seventhYear,
  [researchStages.eighthYear]: texts.eighthYear,
  [researchStages.ninthYear]: texts.ninthYear,
}

const researchStagesInEnglish = {
  [researchStages.initialAppointment]: "Baseline Visit",
  [researchStages.firstYear]: "First Year",
  [researchStages.secondYear]: "Second Year",
  [researchStages.thirdYear]: "Third Year",
  [researchStages.forthYear]: "Forth Year",
  [researchStages.fifthYear]: "Fifth Year",
  [researchStages.sixthYear]: "Sixth Year",
  [researchStages.seventhYear]: "Seventh Year",
  [researchStages.eighthYear]: "Eighth Year",
  [researchStages.ninthYear]: "Ninth Year",
}

const alternativeNames = {
  "00_visit": researchStages.initialAppointment,
  "00_00_visit": researchStages.initialAppointment,
  "first_year": researchStages.firstYear,
  "02_00_visit": researchStages.secondYear,
}

const conventionalNames = {
  [researchStages.initialAppointment]: "00_00_visit",
  [researchStages.secondYear]: "02_00_visit",
}

export const getAppointment = (user, researchStage) => {
  researchStage = normalizeResearchStage(researchStage || user.researchStage)
  if (isCall(researchStage)) {
    return getCall(user, researchStage)
  } else {
    return getVisit(user, researchStage)
  }
}

export const getVisit = (user, researchStage = null) => {
  researchStage = normalizeResearchStage(researchStage || user.visitResearchStage)
  return Object.values(user.visits)
    .find(visit => researchStage == normalizeResearchStage(visit.researchStage))
}

export const getCall = (user, researchStage = null) => {
  researchStage = normalizeResearchStage(researchStage || user.researchStage)
  return Object.values(user.calls)
    .find(call => researchStage == normalizeResearchStage(call.researchStage))
}

export const normalizeResearchStage = (researchStage) => {
  if (researchStage in alternativeNames) {
    return alternativeNames[researchStage]
  }
  return researchStage
}

export const conventionalizeResearchStage = (researchStage) => {
  researchStage = normalizeResearchStage(researchStage)
  return conventionalNames[researchStage] || researchStage
}

export const isInitialAppointment = (researchStage) => {
  return normalizeResearchStage(researchStage) === researchStages.initialAppointment
}

export const isPlannedFollowUpVisit = (researchStage) => {
  return isPlannedVisit(researchStage) && !isInitialAppointment(researchStage)
}

export const isUnplanned = (researchStage) => {
  return conventionalizeResearchStage(researchStage).includes("_00_") === false
}

export const isPlannedVisit = (researchStage) => {
  return isVisit(researchStage) && !isUnplanned(researchStage)
}

export const isVisit = (researchStage) => {
  return conventionalizeResearchStage(researchStage).includes("visit")
}

export const isCall = (researchStage) => {
  return conventionalizeResearchStage(researchStage).includes("call")
}

export const getDisplayName = (researchStage, inEnglish) => {
  researchStage = normalizeResearchStage(researchStage)
  const translation = inEnglish ? researchStagesInEnglish : researchStagesInHebrew
  if (translation[researchStage]) {
    return translation[researchStage]
  } else {
    return inEnglish ? "Unplanned" : texts.unplannedVisit
  }
}

export const getVisitDisplayName = (visit, inEnglish) => {
  const displayName = getDisplayName(visit.researchStage, inEnglish)
  if (visit.doneAt) {
    const formatDate = (date) => moment(date).format("DD/MM/YYYY")
    const dateString =  formatDate(visit.doneAt)
    return `${displayName} ${dateString}`
  }
  return displayName
}

export const sortAppointments = (appointments) => {
  return _.sortBy(appointments, (appointment) => conventionalizeResearchStage(appointment.researchStage))
}

export const getResearchStageType = (researchStage) => {
  if (isUnplanned(researchStage)) {
    return researchStageTypes.unplanned
  } else {
    return normalizeResearchStage(researchStage)
  }
}

export const getStageYear = (researchStage) => {
  researchStage = conventionalizeResearchStage(researchStage)
  return parseInt(researchStage.split("_")[0])
}

export const getAppointmentType = (researchStage) => {
  return isVisit(researchStage) ? "visit" : "call"
}
